import '../styles/ApplyTitle.css';
import React from 'react';

function ApplyTitle() {
  return (
    <section className="atl-root" aria-labelledby="atl-title">
      <div className="atl-rail" data-content-rail="primary">
        <div className="atl-col" data-content-rail="reading">
          <div className="atl-band atl-reveal">
            <p className="atl-eyebrow">
              <span className="atl-eyebrow-dot" aria-hidden="true" />
              Apply
            </p>

            <h1 className="atl-title" id="atl-title">
              <span className="atl-title-line">Send a loan</span>
              <span className="atl-title-line">
                application<span className="atl-title-accent">.</span>
              </span>
            </h1>

            <svg
              className="atl-rule"
              viewBox="0 0 380 14"
              preserveAspectRatio="none"
              aria-hidden="true"
              focusable="false"
            >
              <path d="M 2 9 C 90 2, 200 13, 300 6 S 360 4, 378 8" />
              <path
                className="atl-rule-fade"
                d="M 2 9 C 90 2, 200 13, 300 6 S 360 4, 378 8"
                transform="translate(0 3)"
              />
            </svg>
          </div>

          <p className="atl-intro atl-reveal atl-reveal--delayed">
            Tell Montreaux what you need and send your request in one sitting.{' '}
            <strong>No account or sign-in is needed</strong> — just your name, contact details,
            the amount you have in mind, and what the loan is for.
          </p>

          <svg
            className="atl-mark"
            viewBox="0 0 116 116"
            aria-hidden="true"
            focusable="false"
          >
            <path d="M 8 96 A 54 54 0 0 1 108 58" />
            <path d="M 8 96 A 54 54 0 0 1 108 58" transform="translate(8 6)" opacity="0.45" />
            <circle cx="96" cy="92" r="6" />
          </svg>
        </div>
      </div>
    </section>
  );
}

export default ApplyTitle;